import { useMemo } from 'react';
import { Alert, Divider, Flex, Image, useTheme, Text, Button, ThemeProvider } from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify';

import Footer from 'components/Authenticator/components/Footer';
import { useLabelOptions } from 'contexts/labelOptionsContext';
import { useLocaleState } from 'contexts/localeContext';
import { getTheme } from 'theme';

import accessLimitedImage from './images/accessLimited.svg';

// The provider's error text arrives form-encoded and undecoded.
const decodeMessage = (message) => {
  try {
    return decodeURIComponent(message.replace(/\+/g, ' '));
  } catch {
    return message;
  }
};

const SsoFailurePage = ({ message }) => {
  const { tokens } = useTheme();
  const { labelOptions } = useLabelOptions();
  const { rtl } = useLocaleState();
  const theme = useMemo(() => getTheme(labelOptions.brand), [labelOptions]);

  return (
    <ThemeProvider theme={theme} direction={rtl ? 'rtl' : 'ltr'}>
      <Flex direction="column" alignItems="center" justifyContent="space-between" height="100vh">
        <Divider height={8} backgroundColor={theme.tokens.colors.errorDark.value} />
        <Flex direction="column" alignItems="center" gap="0" padding={tokens.space.medium} maxWidth="100%">
          <Image alt="access limited" src={accessLimitedImage} marginBottom="32px" maxWidth="100%" />
          <Text fontSize={tokens.fontSizes.xl} textAlign="center" marginBottom={tokens.space.medium}>
            {I18n.get('ssoFailurePage.title')}
          </Text>
          {message && (
            <Alert variation="error" marginBottom={tokens.space.small}>
              {decodeMessage(message)}
            </Alert>
          )}
          <Text fontSize={tokens.fontSizes.medium} textAlign="center" marginBottom="24px">
            {I18n.get('ssoFailurePage.contactAdmin')}
          </Text>
          <Button variation="primary" onClick={() => (window.location.href = '/')}>
            {I18n.get('ssoFailurePage.backToLogin')}
          </Button>
        </Flex>
        <Footer />
      </Flex>
    </ThemeProvider>
  );
};

export default SsoFailurePage;
